import { useState } from "react";
import { motion } from "framer-motion";
import { Send } from "lucide-react";
import { toast } from "sonner";

const TIKTOK_URL = "https://www.tiktok.com/@schatten_psyche_";

export const Footer = () => {
  const [email, setEmail] = useState("");

  const subscribe = (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("Bitte gib eine gültige E-Mail-Adresse ein.");
      return;
    }
    toast.success("Notiert. Du stehst auf der Liste für die nächste Freigabe.");
    setEmail("");
  };

  return (
    <footer className="relative border-t border-white/10 bg-void-soft/60 overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-20">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img src="/logo.png" alt="Schattenpsyche Logo" className="w-10 h-10 rounded-full ring-1 ring-white/20" />
              <span className="font-cinzel tracking-[0.25em] text-sm text-white/90">SCHATTENPSYCHE</span>
            </div>
            <p className="text-slate-400 text-sm sm:text-base leading-relaxed max-w-sm">
              Profiler-Psychologie für den Alltag. Lies die Signale. Behalte den Schatten auf deiner Seite.
            </p>
            <a
              href="mailto:schattenpsyche1603@gmail.com"
              data-testid="footer-contact-email"
              className="mt-4 inline-block font-mono text-xs tracking-[0.15em] text-slate-400 hover:text-white transition-colors"
            >
              schattenpsyche1603@gmail.com
            </a>
            <a
              href={TIKTOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-tiktok-social-link"
              className="mt-6 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-slate-400 hover:text-white transition-colors"
            >
              TikTok · @schatten_psyche_
            </a>
          </div>

          <div className="lg:col-span-7">
            <p className="font-mono text-xs uppercase tracking-[0.35em] text-slate-400 mb-4">
              Die Freigabe-Liste
            </p>
            <p className="text-slate-400 text-sm mb-5 max-w-md">
              Band 2 und 3, signierte Exemplare und Bonus-Analysen kommen direkt in dein Postfach.
            </p>
            <form onSubmit={subscribe} className="flex flex-col sm:flex-row max-w-md gap-3">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="deine@email.de"
                data-testid="footer-newsletter-email-input"
                className="flex-1 bg-white/5 border border-white/10 rounded-full px-5 py-3 text-sm text-white placeholder:text-slate-600 focus:outline-none focus:border-white/50 transition-colors"
              />
              <button
                type="submit"
                data-testid="footer-newsletter-submit-button"
                className="glow-btn !px-6 !py-3.5 text-sm w-full sm:w-auto min-h-[48px]"
              >
                <Send className="w-4 h-4" />
                Eintragen
              </button>
            </form>
          </div>
        </div>

        <motion.p
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="font-cinzel font-bold text-[11.5vw] leading-none text-outline text-center select-none whitespace-nowrap"
          aria-hidden="true"
        >
          SCHATTENPSYCHE
        </motion.p>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">
          <span>© 2026 Schattenpsyche. Alle Signale vorbehalten.</span>
          <span>Sichere Zahlung durch Stripe</span>
        </div>
      </div>
    </footer>
  );
};
